import type { ExtraDataType } from '../../common/types.tsx';

class ExtraFormData {
	private data: Record<string, ExtraDataType> = {};

	clear() {
		this.data = {};
	}

	addByKey(key: string, value: ExtraDataType) {
		this.data[key] = value;
	}

	getByKey(key: string) {
		return this.data[key];
	}

	getAll() {
		return this.data;
	}
}

const extraFormData = new ExtraFormData();

const addDataByKey = (key: string, value: ExtraDataType): void => {
	extraFormData.addByKey(key, value);
};

const clear = (): void => {
	extraFormData.clear();
};

const getDataByKey = (key: string) => extraFormData.getByKey(key);

const getData = () => extraFormData.getAll();

export const extraFormDataService = {
	addDataByKey,
	getDataByKey,
	clear,
	getData,
};
